import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.ApprovalPoolLabel`

export default defineMessages({
  levelText: {
    id: `${scope}.levelText`,
    defaultMessage: 'Level {level} approvers',
  },
})
